<template>
  <div class="bg-[#23242A] text-white h-screen appheader p-3" id="content_screen">
    <div class="p-3 flex content-main">
      <div class="custom-full">
        <Nav activeTab="Profile"></Nav>
        <div class="bg-[#2B2C32] rounded-lg max-w-full mb-[80px]">
            <GeneralProfile />
        </div>
      </div>
    </div>
  </div>
</template>




<script lang="ts">
  import {
    defineComponent,
    ref
  } from "vue"
  import {
    mapGetters
  } from "vuex";
  import Nav from './Nav.vue';
  import GeneralProfile from './Profiles/Index.vue';



  export default defineComponent({
    name: "Profile",
    components: {
      Nav,
      GeneralProfile,
    },



    computed: {
      ...mapGetters({
        vg_selectedLocation: 'location/selected'
      }),
    },

  });
</script>